import React from 'react';

export const FinancingOptions: React.FC = () => {
  const options = [
    {
      title: 'All-Cash Purchases',
      description: 'For sellers who need the fastest possible closing and want the certainty of a cash transaction, we can purchase your apartment building with all cash. This eliminates financing contingencies, reduces closing time, and provides maximum certainty. Cash purchases are ideal when you need to close quickly, want to avoid any possibility of financing delays, or simply prefer the simplicity of an all-cash deal.',
      benefits: ['No financing contingency', 'Fastest closing possible', 'Maximum certainty', 'Simplified process']
    },
    {
      title: 'Seller Financing',
      description: 'If you are open to carrying back financing, we can structure a deal that provides you with ongoing income while potentially offering tax advantages through installment sale treatment. Seller financing can result in a higher purchase price, provide you with a steady income stream, and offer attractive interest rates. We handle all payments reliably and can structure terms that work for your financial planning goals.',
      benefits: ['Higher purchase price', 'Ongoing income stream', 'Potential tax benefits', 'Flexible terms']
    },
    {
      title: 'Hybrid Structures',
      description: 'We can create custom financing arrangements that combine cash and seller financing in proportions that work for your situation. Perhaps you need a certain amount of cash at closing but are willing to carry back a portion for tax planning or income purposes. We work with you to design a structure that meets your specific financial objectives while allowing us to acquire your property.',
      benefits: ['Customized to your needs', 'Balance of cash and income', 'Tax planning flexibility', 'Creative solutions']
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Flexible Financing Options
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            We understand that different sellers have different financial goals and preferences. That is why we offer multiple ways to structure the purchase of your apartment building.
          </p>
        </div>

        <div className="space-y-12">
          {options.map((option, index) => (
            <div key={index} className="bg-gray-50 rounded-xl p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {option.title}
              </h3>
              <p className="text-gray-600 leading-relaxed mb-6">
                {option.description}
              </p>
              <div className="grid sm:grid-cols-2 gap-4">
                {option.benefits.map((benefit, idx) => (
                  <div key={idx} className="flex items-center gap-3">
                    <div className="w-6 h-6 bg-teal-500 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                    <span className="text-gray-700">{benefit}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-teal-500 to-cyan-600 rounded-2xl p-12 text-white">
          <div className="max-w-4xl mx-auto text-center">
            <h3 className="text-3xl font-bold mb-6">
              Let Us Structure a Deal That Works for You
            </h3>
            <p className="text-lg mb-8 leading-relaxed opacity-95">
              During our initial conversation, we will discuss your financial goals, timeline, and preferences. Based on this information, we can present financing options that align with your objectives. Whether you prioritize speed, ongoing income, tax efficiency, or maximum cash at closing, we can structure an offer that meets your needs.
            </p>
            <p className="text-lg leading-relaxed opacity-95">
              Our flexibility in financing has allowed us to complete transactions that other buyers could not accommodate. We encourage you to share your ideal scenario with us, and we will work to make it happen.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
